import { useEffect, useState } from "react";
import { getDatasetEditLock } from "@/api";

/**
 * Dataset 편집 잠금(학습 사용 중) 조회 훅.
 *
 * 학습이 실행되는 동안 에피소드 visibility(전역 `excluded`)를 바꾸면 학습 입력이 달라진다.
 * 그래서 서버가 그 write 를 거부한다. 이 훅은 **안내용 힌트**만 제공한다. 조회 직후에도 세션이
 * 시작될 수 있으므로 최종 판정은 저장 시점의 409 다. 조회가 실패하면 잠금 없음으로 degrade 한다
 * (편집을 막지 않는다).
 *
 * StrictMode 재마운트에 안전하도록 Lifecycle 클래스 없이 cancelled 플래그만 쓴다.
 * `enabled` 가 false 면 조회하지 않고 잠금 없음이다.
 */
export function useDatasetEditLock(datasetUuid: string, enabled: boolean = true): boolean {
  const [locked, setLocked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLocked(false);
    if (!enabled) {
      return;
    }
    getDatasetEditLock(datasetUuid)
      .then((lock) => {
        if (!cancelled) {
          setLocked(lock.locked);
        }
      })
      .catch(() => {
        // 조회 실패(503 포함)는 안내를 표시하지 못할 뿐이다. 저장 시 서버가 다시 판정한다.
      });
    return () => {
      cancelled = true;
    };
  }, [datasetUuid, enabled]);

  return locked;
}
